module.exports = __webpack_public_path__ + "img/donut5.e646efa5.png";